import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { GenEncryptKey } from "../../../routes/cryptography";

import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class GenEncryptKeyView extends Component {
  constructor() {
    super();
    this.state = {};
  }

  handleSubmit(e) {
    try {
      e.preventDefault();
      GenEncryptKey().then((result) => {
        try {
          if (result.status === 200) {

           FileDownload(Buffer.from(result.data.privkey).buffer, "privkey32");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        } catch (error) {
          //console.log(error);
          document.getElementById("view").style.borderColor = "red";

          this.setState({
            statusGenPrivKey: "Ошибка",
          });
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() { }

  render() {
    return (
      <div className="container " id="genreq" style={{ textAlign: "center" }}>
        <h6 className="major" style={{ marginRight: "20px" }}>
          Генерация 32байтового ключа
        </h6>
        <Form onSubmit={this.handleSubmit}>
          <div className="sm-4 ">
            <Button type="submit" size="sm">
              Сгенерировать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(GenEncryptKeyView));
